import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges
} from '@angular/core'
import { Router } from '@angular/router'
import { LinkModel } from '@flocasts/experience-service-types'

@Component({
  selector: 'flo-slim-header',
  templateUrl: `./slim-header.component.html`,
  styleUrls: ['./slim-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlimHeaderComponent implements OnChanges {
  @Input() public title: string
  @Input() public cta: string | undefined

  @Input() public link: LinkModel
  @Input() public actions: LinkModel[] | null = null

  @Output() public ctaClicked = new EventEmitter<boolean>()

  /**
   * Cached array of links to render as action buttons.
   * Computed in ngOnChanges when inputs change.
   * Prioritizes the actions array if present, falls back to single link for backwards compatibility.
   */
  public actionLinks: LinkModel[] = []

  constructor(private readonly router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.actions || changes.link) {
      this.actionLinks = this.actions && this.actions.length > 0 ? this.actions : this.link ? [this.link] : []
    }
  }

  public ctaClick(link: LinkModel) {
    if (this.ctaClicked.observed) {
      this.ctaClicked.emit(true)
    } else if (link.target === '_blank') {
      // Let browser handle external links via href and target attributes
      return
    } else if (!!link.url) {
      this.router.navigateByUrl(link.url)
    }
  }
}
